module.exports = __webpack_public_path__ + "img/ybywzhfw_charact_2.fd2a48e5.svg";